module.exports = __webpack_public_path__ + "static/media/irc.7d9e231e.svg";